
define('template!ordersDetailOrderPhrasesPickerView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="phrase-picker-container">\n    <div class="picker-search">\n        <input type="text" class="picker-search-input" placeholder="' +
((__t = ( _.i18n('common.search') )) == null ? '' : __t) +
'..." />\n    </div>\n    <div class="picker-list"></div>\n    <div class="picker-footer">\n        <span class="picker-selection-count">0 ' +
((__t = ( _.i18n('common.selected') )) == null ? '' : __t) +
'</span>\n        <div class="picker-buttons">\n            <button class="btn btn-default btn-flat picker-cancel">' +
((__t = ( _.i18n('common.cancel') )) == null ? '' : __t) +
'</button>\n            <button class="btn btn-primary picker-confirm" disabled>' +
((__t = ( _.i18n('common.confirm') )) == null ? '' : __t) +
'</button>\n        </div>\n    </div>\n</div>\n';

}
return __p
};});

